export const STUCK_COMBOS_IDS = [
  'tipo_mercado_campañas',
]
